



















import Vue from 'vue'
import { DropdownElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'DropdownEl',

  mounted () {
    this.selected = typeof this.templateItemData.value !== 'undefined'
      ? this.templateItemData.value : this.templateItemData.list[0].key
  },

  data: () => ({
    selected: ''
  }),

  props: {
    templateItemData: {
      type: Object as () => DropdownElInterface,
      required: true
    }
  }
})
